var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnSysWidget002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    fill: "#F0E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 946.176H256c-98.304 0-178.176-79.872-178.176-178.176V256c0-98.304 79.872-178.176 178.176-178.176h512c98.304 0 178.176 79.872 178.176 178.176v512c0 98.304-79.872 178.176-178.176 178.176zM256 135.168c-66.56 0-120.832 54.272-120.832 120.832v512c0 66.56 54.272 120.832 120.832 120.832h512c66.56 0 120.832-54.272 120.832-120.832V256c0-66.56-54.272-120.832-120.832-120.832H256z",
    fill: "#8B5CF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 515.6864c119.3984 0 212.992-51.2 212.992-116.736s-93.5936-116.736-212.992-116.736-212.992 51.2-212.992 116.736 93.5936 116.736 212.992 116.736z m0-204.3904c99.7376 0 184.1152 40.1408 184.1152 87.6544 0 47.5136-84.3776 87.6544-184.1152 87.6544s-183.9104-40.1408-183.9104-87.6544c0-47.5136 84.1728-87.6544 183.9104-87.6544z",
    fill: "#8B5CF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M710.4512 486.6048c-7.9872 0-14.5408 6.5536-14.5408 14.5408 0 47.5136-84.1728 87.6544-183.9104 87.6544s-183.9104-40.1408-183.9104-87.6544c0-7.9872-6.5536-14.5408-14.5408-14.5408-7.9872 0-14.5408 6.5536-14.5408 14.5408 0 65.3312 93.5936 116.736 212.992 116.736s212.992-51.2 212.992-116.736c0-7.9872-6.5536-14.5408-14.5408-14.5408z",
    fill: "#8B5CF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M710.4512 610.5088c-7.9872 0-14.5408 6.5536-14.5408 14.5408 0 47.5136-84.1728 87.6544-183.9104 87.6544s-183.9104-40.1408-183.9104-87.6544c0-7.9872-6.5536-14.5408-14.5408-14.5408-7.9872 0-14.5408 6.5536-14.5408 14.5408 0 65.3312 93.5936 116.736 212.992 116.736s212.992-51.2 212.992-116.736c0-7.9872-6.5536-14.5408-14.5408-14.5408z",
    fill: "#8B5CF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnSysWidget002);
export default __webpack_public_path__ + "static/media/sn_sys_widget_002.8b60fa746f5867fb98025210967398cb.svg";
export { ForwardRef as ReactComponent };